import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import RoamingStore from '../../stores/RoamingStore';
import { Segment } from '../../stores/SegmentStore';
import EeaCountryCard from './EeaCountryCard';
import NonEeaCountryCard from './NonEeaCountryCard';

interface RoamingCountryCardProps {
  segment: Segment;
  countriesWithoutAutoDayPackage?: string[];
  roamingStore?: RoamingStore;
}

@observer
class RoamingCountryCard extends React.Component<RoamingCountryCardProps> {
  public render() {
    const {
      roamingStore: { selectedCountry, operatorList },
      segment,
      countriesWithoutAutoDayPackage,
    } = this.props;
    if (!selectedCountry) {
      return null;
    }

    const showAutoDayPackageInfo = !countriesWithoutAutoDayPackage?.includes(selectedCountry.isoCode);

    return (
      <>
        {operatorList.description && this.renderDescriptionNotice()}
        {selectedCountry.eea ? (
          <EeaCountryCard segment={segment} isoCode={selectedCountry.isoCode} />
        ) : (
          <NonEeaCountryCard segment={segment} showAutoDayPackageInfo={showAutoDayPackageInfo} />
        )}
      </>
    );
  }

  private renderDescriptionNotice = () => {
    const {
      roamingStore: { operatorList },
    } = this.props;

    return (
      <>
        <Notice>
          <span dangerouslySetInnerHTML={{ __html: operatorList.description }} />
        </Notice>
        <Separator spacing={'xsmall'} color={'invisible'} />
      </>
    );
  };
}

export default inject('roamingStore')(RoamingCountryCard);
